// Event names for the editor tour, the three step walkthrough shown once on a
// user's first visit to a project editor.
//
// Single source of truth: import from here at every call site so renames stay in
// sync and a typo cannot silently split one event into two.
//
// The `first_project_created` / `first_project_edit` / `first_project_published`
// activation events are deliberately NOT here. They are fired from the mark
// helpers in lib/api/onboarding.ts, are referenced by existing PostHog insights,
// and two of them carry Google Ads conversion values. Keeping them out of this
// file avoids implying they belong to the tour.
export const TOUR_EVENTS = {
  /** A step became visible. Fires once per step per session. */
  STEP_SHOWN: "editor_tour_step_shown",
  /** User moved forward off a step. */
  STEP_ADVANCED: "editor_tour_step_advanced",
  /** User skipped. Skipping ends the whole tour, not just the step. */
  SKIPPED: "editor_tour_skipped",
  /** User reached the end of the last step. */
  COMPLETED: "editor_tour_completed",
} as const;

export type TourEvent = (typeof TOUR_EVENTS)[keyof typeof TOUR_EVENTS];
